import React from "react";
import "./tweet.css";
import TweetEmbed from "react-tweet-embed";

function Transgenders() {
  return (
    <div
      style={{ padding: "0.3rem", backgroundColor: "#81c9cf" }}
      id="trans"
      className="trans"
    >
      <h1 style={{ margin: "2rem 0", textAlign: "center" }}>Transgenders</h1>
      <div style={{ display: "flex", margin: "2rem 0" }}>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
            marginRight: "2rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/4.1.jpg"}></img>
          <div>
            <h5 style={{ color: "whitesmoke" }}>
              <br /><br /><br /> Punjab to open schools for transgenders: Murad Raas
            </h5>
            {/* <h6 style={{ marginLeft: "20rem", color: "whitesmoke" }}>
              ~ Brian Kiely
            </h6> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/4.2.jpg"}></img>
          <div style={{ margin: "2rem 0" }}>
            <h5 style={{ color: "whitesmoke" }}>
              Historic decision of our KARNATAKA government, Transgenders in
              Public Employment Karnataka becomes the first state to provide 1%
              reservation for transgenders in public employment.
            </h5>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", margin: "2rem 0" }}>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
            marginRight: "2rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/4.3.jpg"}></img>
          <div>
            <h5 style={{ color: "whitesmoke" }}>
              <br />Transgenders from Odisha can now apply for recruitment as
              Sub-Inspector (477 posts) and constable (244 posts) in Odisha
              police on contractual basis. <br />The application process for
              recruitment exam will commence on June 22.
            </h5>
            {/* <h6 style={{ marginLeft: "20rem", color: "whitesmoke" }}>
              ~ Brian Kiely
            </h6> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/4.4.jpg"}></img>
          <div style={{ margin: "2rem 0" }}>
            <h5 style={{ color: "whitesmoke" }}>
              A special drive was conducted by Social Welfare Dept last week and
              provided new Welfare Board ID cards to 225 Transgenders in Kovai.
              This recognition was long due for most of them. Now they will be
              eligible for all the Govt schemes.
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Transgenders;
